import React, { useContext } from "react";
import {
  Text,
  Checkbox,
  Date,
  Email,
  File,
  Number,
  Select,
  Textarea,
  Amount,
  MobileNumber,
} from "../Components/fields/AllFields";
import FormContext from "../context/FormContext";

const PreviewForm = () => {
  const context = useContext(FormContext);
  const { Fields, FormInfo, formResponse, handleResponse } = context;
  const components = {
    Text: Text,
    CheckBox: Checkbox,
    Date: Date,
    Email: Email,
    File: File,
    Number: Number,
    Select: Select,
    TextArea: Textarea,
    Amount: Amount,
    MobileNumber: MobileNumber,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formResponse);
  };

  return (
    <div className="w-75 m-auto my-4">
      <img
        style={{ width: 100 }}
        src={`https://erp.eshiksa.net/DirectFeesv3/assets/img/${FormInfo.image}`}
        alt="logo"
      />
      <h2 className="text-center">{FormInfo.formName}</h2>
      <form onSubmit={(e) => handleSubmit(e)}>
        {Fields.map((Field, i) => {
          const Component = components[Field.Component];
          return (
            <Component
              handleResponse={handleResponse}
              FormInfo={FormInfo}
              key={i}
              Item={Field}
            />
          );
        })}
        <div className="text-center">
          <button disabled type="submit" className="btn btn-primary ">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default PreviewForm;
